import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { Divider, Icon } from "../";
import { images } from "../../assets";
import ContactModal from "../../pages/car-detail/contactModal";
import { fileUrl } from "../../redux/base/url";
import { Car } from "../../redux/cars/types/car";
import { getLocalized } from "../../redux/localization";
import "./style.scss";

const size = 16;
const iconStyle = { marginInlineEnd: 2 };
const CarCard = ({ data }: { data: Car }) => {
  const history = useHistory();
  const localize = useSelector(getLocalized);
  const [showContact, setShowContact] = useState(false);
  return (
    <div className="mainCardDiv ">
      {data && (
        <ContactModal
          name={`${data.CarBrand} ${data.CarModel} ${data.CarVersion} ${data.CarModel}`}
          car={data}
          open={showContact}
          close={() => setShowContact(false)}
        />
      )}
      <div className="w-100">
        <div
          className={
            data.HasCampaign
              ? "cursor-pointer cardImageCmp justify-content-between"
              : "cursor-pointer cardImageCmp justify-content-end"
          }
          onClick={() => {
            history.push("/car-details/" + data.Id);
          }}
        >
          {data.HasCampaign && (
            <div className="campaignContainerMain">
              <div className="campaignContainer">{data.CampaignText}</div>
            </div>
          )}
          <img
            className="carCardImage "
            src={fileUrl(data.MainImage)}
            width={275}
            alt=""
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = images.error;
            }}
          />
        </div>
        <div className="mt-1 w-100">
          <Col xs={12}>
            <span className="cardTitle">
              {data.CarBrand} {data.CarModel}
            </span>
          </Col>
          <Col xs={12} style={{ minHeight: 48 }}>
            <span className="cardSubTitle">
              {data.CarVersion} {data.CarPack}
            </span>
          </Col>
        </div>
        <Divider />

        <Row className="w-100">
          <Col xs={4}>
            <span>
              <Icon icon="gas-station" size={size} style={iconStyle} />{" "}
              <span className="cardUtilText">
                {data.FuelType.toLocaleUpperCase()}
              </span>
            </span>
          </Col>
          <Col xs={4}>
            <span>
              <Icon icon="gear-lever" size={size} style={iconStyle} />
              <span className="cardUtilText">
                {data.GearType.toLocaleUpperCase()}
              </span>
            </span>
          </Col>
          <Col xs={4}>
            <span>
              <Icon icon="car" size={size} style={iconStyle} />
              <span className="cardUtilText">
                {data.BodyType.toLocaleUpperCase()}
              </span>
            </span>
          </Col>
        </Row>
        <Row className="w-100">
          <Col xs={4}>
            <span>
              <Icon icon="engine-motor" size={16} style={iconStyle} />
              <span className="cardUtilText">
                {data.Enginecc > 0 ? data.Enginecc + "  CC" : "- "}
              </span>
            </span>
          </Col>
          <Col xs={4}>
            <span>
              <Icon icon="fuel-burn" size={size} style={iconStyle} />
              <span className="cardUtilText">
                {parseInt(data.Consumption.split("-")[0]) > 0
                  ? data.Consumption.split("-")[0]
                  : "-"}{" "}
                L/100KM
              </span>
            </span>
          </Col>
          <Col xs={4}>
            <span>
              <Icon icon="co2" size={size} style={iconStyle} />
              <span className="cardUtilText">
                {parseInt(data.Carbon.split("-")[0]) > 0
                  ? data.Carbon.split("-")[0]
                  : "-"}{" "}
                G/KM
              </span>
            </span>
          </Col>
        </Row>

        {data.ShowStartingPrice && data?.StartingPrice > 0 ? (
          <div
            className="btnTeklifOlustur carCardFooter d-flex justify-content-between align-items-center mt-2 w-100 px-2"
            onClick={() => {
              if (data.ShowStartingPrice && data?.StartingPrice > 0) {
                return history.push("/car-details/" + data.Id);
              } else {
                return setShowContact(true);
              }
            }}
          >
            <div>
              <div className="carCardFooterText">
                <div className="carCardFooterText">
                  {localize.getString("monthlyprice")}
                </div>
                {localize.formatString(
                  localize.getString("pricestartingfrom"),
                  <span className="carCardFooterPriceText btnTeklifOlustur">
                    {new Intl.NumberFormat("tr-TR", {
                      maximumSignificantDigits: 20,
                    }).format(data?.StartingPrice)}{" "}
                    TL
                  </span>
                )}
              </div>
            </div>
            <div>{<Icon icon="right" size={16} />}</div>
          </div>
        ) : (
          <div
            className="btnTeklifTalepEt carCardFooter d-flex justify-content-between align-items-center mt-2 w-100 px-2"
            onClick={() => {
              if (data.ShowStartingPrice && data?.StartingPrice > 0) {
                return history.push("/car-details/" + data.Id);
              } else {
                return setShowContact(true);
              }
            }}
          >
            <div>
              <div className="carCardFooterText">
                <span className="carCardFooterPriceText btnTeklifTalepEt">
                  {"Teklif Talep Et"}
                </span>
              </div>
            </div>
            <div>{<Icon icon="right" size={16} />}</div>
          </div>
        )}
      </div>
    </div>
  );
};
export default CarCard;
